module.exports = __webpack_public_path__ + "static/affiliates-1ddbdb434b0d145d791e583931927709.png";